import { createStore } from 'redux';
import reducer from './reducer.jsx';

export default function configureStore() {
    const store = createStore(reducer);
    return store;
};


// WEBPACK FOOTER //
// ./App/redux/store.jsx